// TODO: move configs to melzo/src
export default {
    serverUrl: 'https://dev-api.melzoguru.in/',
    // serverUrl: 'http://localhost:3001/',
};